import TableEmbed from '../../TableEmbed';

class EmbeddedTableEmbed extends TableEmbed {
  protected override isEmbedded = true;
}

export default EmbeddedTableEmbed;
